var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"domain-help"},[_c('Guide',{attrs:{"content":_vm.content,"width":"x-small","buttonText":"Find DNS Settings","contentHeading":"Mange your domain name","closeLink":_vm.closeLink,"nextLink":_vm.nextLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }